module.exports = __webpack_public_path__ + "files/b92020c25c54f54892a0d52f976393de.png";